<template>
  <div
    class="recordComWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="sheetsContent commonOrderContent">
      <div class="formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="选择日期" v-if="routerType === 'INSPECTION'">
            <el-date-picker
              v-model="formInline.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="搜索">
            <el-input v-model="formInline.searchTxt" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSizeChange(10)"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="disabled"
              type="primary"
              plain
              @click="exportFun"
              v-if="
                judgeAuthority(
                  routerType === 'INSPECTION'
                    ? 'houqinguanli:xunjianguanli:patrolRecords:export'
                    : 'houqinguanli:baoyangguanli:maintainRecords:export'
                )
              "
              ><i class="el-icon-download el-icon--left"></i>
              EXCEL
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tabCardBox">
        <div class="orderCardItem">
          <el-table
            :data="tableData"
            stripe
            border
            style="width: 100%"
            class="tabWrap"
            height="93%"
            :cell-style="cellStyle"
            @cell-click="cellClick"
            :header-cell-style="{
              'background-color': '#F7F7F7',
            }"
          >
            <el-table-column
              v-for="(v, i) in tabHead"
              :key="i"
              :prop="v.prop"
              :label="v.label"
              :min-width="flexWidth(v.prop, tableData, v.label)"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row[v.prop] &&
                    (v.prop == 'realityUser' || v.prop == 'planUser')
                  "
                >
                  <el-link
                    type="primary"
                    v-for="(item, index) in v.prop == 'realityUser'
                      ? scope.row.truehandlers
                      : scope.row.truehandlers"
                    :key="item.id"
                    @click="toUserPage(item)"
                    >{{
                      index ==
                      (v.prop == "realityUser"
                        ? scope.row.truehandlers?.length - 1
                        : scope.row.truehandlers?.length - 1)
                        ? item.name
                        : `${item.name}、`
                    }}</el-link
                  >
                </span>
                <span v-else>{{ scope.row[v.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            style="margin-top: 10px; text-align: right"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <PlanDetails v-if="planDetails" :activeItem="activeItem" />
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  flexWidth,
  exportExcelFun,
  judgeAuthority,
} from "@/assets/js/utils";
import { handleRecordTableData } from "@/assets/utils/handleData";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import PlanDetails from "@/components/houqinguanli/baoyangguanli/PlanDetails";
import axios from "axios";
import { exportBlobFileFun } from "@/assets/utils/exportWord";
export default {
  components: { PlanDetails },
  data() {
    return {
      disabled: false,
      planDetails: false,
      formInline: {
        searchTxt: "",
        time: [],
      },
      routerType: "",
      tabHead: [],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      activeItem: {},
    };
  },
  methods: {
    flexWidth,
    judgeAuthority,
    toUserPage(data) {
      this.$router.push({
        name: "authority",
        params: { userId: data.id },
      });
    },
    cellStyle(row) {
      if (
        (row.column.label === "设备保养进度" ||
          row.column.label === "巡检点" ||
          row.column.label === "巡检计划" ||
          row.column.label === "巡检路线") &&
        !row.row.deleted
      ) {
        return "color:#28CCCB;cursor: pointer;";
      }
    },
    cellClick(row, column) {
      if (
        (column.label == "设备保养进度" || column.label == "巡检点") &&
        !row.deleted
      ) {
        this.activeItem = {
          taskId: row.taskid,
          routerType: this.routerType,
        };
        this.planDetails = true;
      }
      if (
        (column.label == "巡检计划" || column.label == "巡检路线") &&
        !row.deleted
      ) {
        this.$router.push({
          name: column.label == "巡检计划" ? "patrolPlan" : "patrolRoute",
          params: {
            name: column.label == "巡检计划" ? row.planname : row.routename,
          },
        });
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    async getList() {
      this.tableData = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.patrolRecordsGetList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        beginDate: this.formInline.time ? this.formInline.time[0] : null,
        endDate: this.formInline.time ? this.formInline.time[1] : null,
        textSearch: this.formInline.searchTxt,
        sourceType: this.routerType,
        source: "web",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = handleRecordTableData(res.data.data.data);
        this.page.total = res.data.data.totalElements;
      }
    },
    getTabHead() {
      if (this.routerType === "MAINTENANCE") {
        this.tabHead = [
          { label: "计划名称", prop: "planname" },
          { label: "设备数量", prop: "total" },
          { label: "计划执行时间", prop: "planTime" },
          { label: "设备保养进度", prop: "point" },
          { label: "计划保养人", prop: "planUser" },
          { label: "实际保养人", prop: "realityUser" },
          { label: "计划完成度", prop: "degreeNum" },
        ];
      } else if (this.routerType === "INSPECTION") {
        this.tabHead = [
          { label: "巡检计划", prop: "planname" },
          { label: "巡检路线", prop: "routename" },
          { label: "计划巡检时间", prop: "planTime" },
          { label: "巡检点", prop: "point" },
          { label: "计划巡检人", prop: "planUser" },
          { label: "实际巡检人", prop: "realityUser" },
          { label: "巡检完成度", prop: "degreeNum" },
        ];
      }
    },
    exportExcel() {
      let title = "";
      if (this.routerType === "INSPECTION") {
        title = "巡检记录";
        title += this.formInline.time
          ? `(${this.formInline.time[0]}-${this.formInline.time[1]})`
          : "";
      } else if (this.routerType === "MAINTENANCE") {
        title = "保养记录";
      }
      exportFile.xlsxFile(XLSX, title, {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },
    exportFun() {
      this.disabled = true;
      let timer = setTimeout(() => {
        this.$message.info("文件正在下载中,请稍后!");
      }, 500);
      let params = {
        pageSize: this.page.size,
        page: this.currentPage - 1,
        beginDate: this.formInline.time ? this.formInline.time[0] : null,
        endDate: this.formInline.time ? this.formInline.time[1] : null,
        textSearch: this.formInline.searchTxt,
        sourceType: this.routerType,
        source: "web",
      };
      let token = window.sessionStorage.getItem("token");
      let http = window.jujiParams.baseURL;
      axios({
        timeout: 6 * 60 * 1000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "X-Authorization": `Bearer ${token}`,
        },
        url: http + `/api/odoo/inspectionTask/plan/downloadRecordPageExcel`,
        method: "get",
        responseType: "blob",
        params,
      })
        .then((res) => {
          this.disabled = false;
          try {
            let title = "巡检记录";
            title += this.formInline.time
              ? `(${this.formInline.time[0]}-${this.formInline.time[1]}).xls`
              : ".xls";
            exportBlobFileFun(res.data, title);
            clearTimeout(timer);
          } catch (err) {
            console.log("---catch-----", err);
            this.$message.error(err);
            clearTimeout(timer);
          }
        })
        .catch((error) => {
          this.disabled = false;
          clearTimeout(timer);
          this.$message.error(JSON.parse(error.response).message);
        });
    },
  },
  created() {
    this.routerType =
      this.$route.path == "/maintainRecords" ? "MAINTENANCE" : "INSPECTION";
    if (this.$route.path == "/patrolRecords") {
      this.formInline.time = [
        dateFtt(
          "yyyy-MM-dd",
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
        ),
        dateFtt("yyyy-MM-dd", new Date()),
      ];
    }
    this.getTabHead();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.recordComWrap {
  @include setFlexCenter;
  .sheetsContent {
    width: 98%;
    height: 96%;
    ::v-deep .el-select .el-input__inner {
      vertical-align: bottom !important;
    }
    ::v-deep .el-input--suffix .el-input__inner {
      vertical-align: bottom !important;
    }
  }
}
</style>
